import {applyMiddleware, compose, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {thunk} from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';

import rootReducer from '../reducers/index';
import {logger} from "redux-logger/src";

import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {createBlacklistFilter} from 'redux-persist-transform-filter';

import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/index.saga";

export default function configureStore(preloadedState) {
    const sagaMiddleware = createSagaMiddleware();
    // const middlewares = [sagaMiddleware,thunkMiddleware];
    // if (process.env.NODE_ENV === `development`) {
    //     middlewares.push(logger);
    // }

    // const middlewareEnhancer = applyMiddleware(...middlewares);
    const middlewareEnhancer = applyMiddleware(sagaMiddleware);

    const enhancers = [middlewareEnhancer];
    // const composedEnhancers = process.env.NODE_ENV === `development`
    //     ? composeWithDevTools(...enhancers) : compose(...enhancers);
    const composedEnhancers = process.env.NODE_ENV === `development`
        ? compose(...enhancers) : compose(...enhancers);


    const rootPersistConfig = {
        key: 'koochi-root',
        storage: storage,
        blacklist: [],
        whitelist: ['shoppingCart', 'prevSearchHistory'],
        transforms: [
            createBlacklistFilter('shoppingCart', 'prevSearchHistory', ['apiCarts'])
        ]
    }

    const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

    let store = createStore(persistedReducer, preloadedState, composedEnhancers);

    let persistor = persistStore(store);

    sagaMiddleware.run(rootSaga);

    return {store, persistor};

}
